import { makeAutoObservable } from 'mobx'
import { type IIconsVector } from 'shared/ui'
import type {
  IAutomationLogExecutionStatus,
  IResponseAutomationLog,
  IResponseAutomationLogResult,
} from '../api'

export class AutomationLog {
  id: number
  callback_id!: string
  action!: string
  entity_id!: string
  entity_type!: string
  executed_at!: string
  failed_reason!: null | string
  payload!: null | string
  status!: IAutomationLogExecutionStatus
  step!: string
  url!: null | string
  contact_name!: null | string
  contact_phone!: null | string
  result!: IResponseAutomationLogResult

  constructor(item: IResponseAutomationLog) {
    this.id = item.id
    this.syncOrigin(item)

    makeAutoObservable(this)
  }

  syncOrigin = (item: IResponseAutomationLog) => {
    this.callback_id = item.callback_id
    this.entity_id = item.entity_id || ''
    this.entity_type = item.entity_type || ''
    this.action = item.action
    this.status = item.status
    this.executed_at = item.executed_at
    this.failed_reason = item.failed_reason
    this.step = item.step
    this.payload = item.payload
    this.url = item.url
    this.contact_name = item.contact_name
    this.contact_phone = item.contact_phone
    this.result = item.result
  }

  get sourceIcon(): IIconsVector | null {
    switch (this.entity_type) {
      case 'hs_workflow':
      case 'hs_contact':
        return 'hubspot'
      default:
        return 'salesmessage'
    }
  }

  get sourceTitle(): string | null {
    switch (this.entity_type) {
      case 'hs_workflow':
        return 'Workflow'
      case 'message_id':
        return 'Message ID'
      case 'hs_contact':
        return 'HS Contact'
      case 'contact_id':
        return 'Contact ID'
      default:
        return this.entity_type
    }
  }
}
